import React, {useState, useEffect, Fragment} from 'react';
import {ConfirmationIcon} from '@bizzabo/icons';
import { sendAnalytics } from 'utils/analyticsUtils';

const sendAnalyticsEvent = (sharedLink, entityText) => {
    const possibleOptions = ['speaker', 'session'];

    if (possibleOptions.includes(entityText)) {
        const eventName = entityText === 'speaker' ? 'shareSpeakerLink' : 'shareSessionLink';
        sendAnalytics(eventName, {
            sharedLink
        });
    }
};

function CopyInputToClipboard({textToCopy, entityText}) {
    const [copyWasClicked, setCopyWasClicked] = useState(false);
    let timerId = null;

    const copyToClipboard = () => {
        const elementToShare = document.getElementById('copy-text');
        elementToShare.select();
        // For mobile devices //
        elementToShare.setSelectionRange(0, 99999);
        // Copy the text inside the text field //
        document.execCommand('copy');
        sendAnalyticsEvent(textToCopy, entityText);

        setCopyWasClicked(true);
        timerId = setTimeout(function(){
            setCopyWasClicked(false);
        }, 3000);
    };
    useEffect(() => () => {
        /* cleanUp */
        if (timerId != null){
            timerId.clearTimeout();
        }
    }, []);

    return (
        <Fragment>
            <div className="copy-input-to-clipboard">
                <div className="input-group popover-content">
                    <input type="text" className= "form-control" value={textToCopy} title={textToCopy} id="copy-text" readOnly/>
                    <span className="input-group-btn copy-btn">
                        <button className="btn custom-color color-1-background" type="button" onClick={copyToClipboard}>
                            {copyWasClicked ? <ConfirmationIcon fill="var(--page-contrast-to-main-color, #EEE)" /> : 'COPY'}
                        </button>
                    </span>
                </div>
            </div>
            {copyWasClicked && <p className="success-message color-1">Link copied to clipboard</p>}
        </Fragment>
    );
}

export default CopyInputToClipboard;
